import {Grow} from '@mui/material'
import {getLocalStorage, notification, useErrorHandler} from 'app/utils'
import {FC, useState} from 'react'
import {getAccountsReq, loginPuyaReq} from '../auth/apis'
import {Button, Dialog, DialogBody, DialogHeader} from 'app/components'

interface CardItemProps {
  item: any
}

export const CardItem: FC<CardItemProps> = ({item}) => {
  const [loading, setLoading] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)
  const errorHandler = useErrorHandler()
  const [accounts, setAccounts] = useState([])
  const [openAccountsDialog, setOpenAccountsDialog] = useState(false)

  const handleLoginPuya = (userId: any) => {
    if (btnLoading) return
    setBtnLoading(true)
    loginPuyaReq({userId})
      .then((res) => {
        if (res?.data.status === 'error') {
          notification.danger(res?.data.data)
          return
        }
        window.open(res?.data.data, '_blank')
        setOpenAccountsDialog(false)
      })
      .catch(errorHandler)
      .finally(() => setBtnLoading(false))
  }
  const loginToPuya = () => {
    if (getLocalStorage('access_token')) {
      if (loading) return
      setLoading(true)
      getAccountsReq()
        .then((res) => {
          if (res?.data.status === 'error') {
            window.open(item.link)
            return
          }
          let result = res?.data?.data
          if (result.length === 0) {
            notification.danger('شما عضو این سامانه نیستید')
            return
          } else if (result.length === 1) {
            handleLoginPuya(result[0])
          } else {
            setAccounts(result)
            setOpenAccountsDialog(true)
          }
        })
        .catch(errorHandler)
        .finally(() => setLoading(false))
    } else {
      window.open(item.link)
    }
  }
  const handleOpenItem = () => {
    if (item.link === 'http://puya.birjand.ac.ir/') loginToPuya()
    else window.open(item.link, '_blank', 'noreferrer')
  }
  const handleAccounts = () => {
    return (
      <Dialog screen='md'>
        <DialogHeader title='انتخاب حساب کاربری' onClose={() => setOpenAccountsDialog(false)} />
        <DialogBody>
          <div className='alert alert-primary'>
            شما در این سامانه دارای <b>{accounts.length}</b> حساب کاربری می باشید یک مورد را انتخاب
            نمایید
          </div>
          {accounts.map((acc: any) => (
            <Button
              className='btn btn-lg btn-success my-2'
              loading={btnLoading}
              title={acc}
              fullWidth
              onClick={() => handleLoginPuya(acc)}
            />
          ))}
        </DialogBody>
      </Dialog>
    )
  }
  return (
    <>
      {openAccountsDialog && handleAccounts()}
      <Grow key={item.id} in={true} timeout={150 * (item.id + 2)}>
        <div className='col-md-3'>
          <div
            className={`card card-xxl-stretch mb-4 bg-hover-primary text-hover-white hoverable`}
            onClick={() => handleOpenItem()}
          >
            <div className='card-header py-2'>
              <div
                className='card-body d-flex flex-column flex-center pt-0 pb-3'
                style={{height: 150}}
              >
                <i style={{fontSize: 72}} className={`las text-gray-700 ${item.icon}`}></i>
                <span className='fs-4 mt-1'> {item.title}</span>
              </div>
            </div>
          </div>
        </div>
      </Grow>
    </>
  )
}
